import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import { Table, Form, Button, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { trimAndLimit } from "utils/general";
import { timeZonesListFetch } from "actions";

const DataTable = ({ showUpdateForm, setDeleteRowId, setDeleteModalShow, filterQuery }) => {
  const dispatch = useDispatch();
  const timeZonesState = useSelector((state) => state.timeZonesState);

  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(timeZonesListFetch());
  }, [dispatch]);

  useEffect(() => {
    if (timeZonesState.timeZonesList?.length > 0) {
      setData(timeZonesState.timeZonesList);
    }
    setLoading(false);
  }, [timeZonesState.timeZonesList]);

  const getDesc = (val) => {
    let desc = trimAndLimit(val, 20);
    return desc === "null" || desc === null ? "" : desc;
  };

  const filteredData = data.filter(
    (row) =>
      row.name.toLowerCase().includes(filterQuery.toLowerCase()) ||
      (row.offset && row.offset.toLowerCase().includes(filterQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const headers = [
    {
      prop: "select",
      title: (
        <Form.Check
          type="checkbox"
          onChange={(e) => {
            const isChecked = e.target.checked;
            setData((prevData) =>
              prevData.map((row) => ({ ...row, isSelected: isChecked }))
            );
          }}
        />
      ),
      isSortable: false,
    },
    { prop: "name", title: "Name", isSortable: true },
    { prop: "offset", title: "Offset", isSortable: true },
    { prop: "description", title: "Description", isSortable: false },
    { prop: "Action", title: "Action", isSortable: false },
  ];

  return (
    <>
      <DatatableWrapper body={paginatedData} headers={headers}>
        <Table>
          <TableHeader />
          <TableBody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={row.isSelected || false}
                    onChange={() => {
                      setData((prevData) =>
                        prevData.map((item) =>
                          item.id === row.id
                            ? { ...item, isSelected: !item.isSelected }
                            : item
                        )
                      );
                    }}
                  />
                </td>
                <td>{row.name}</td>
                <td>{row.offset}</td>
                <td>{getDesc(row.description)}</td>
                <td>
                  <div className="d-flex justify-content-around">
                    <Image
                      src="/assets/images/modal-edit.svg"
                      onClick={() => showUpdateForm(row.id)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </TableBody>
        </Table>
      </DatatableWrapper>

      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="d-flex align-items-center">
          <Button
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
            className="previous-btn-dataTable me-2"
          >
            First
          </Button>
          <Button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="previous-btn-dataTable me-2"
          >
            Previous
          </Button>
          {Array.from({ length: totalPages }, (_, i) => (
            <Button
              key={i}
              onClick={() => handlePageChange(i + 1)}
              disabled={i + 1 === currentPage}
              className={`mx-1 ${
                i + 1 === currentPage
                  ? "previous-btn-dataTable-active"
                  : "previous-btn-dataTable"
              }`}
            >
              {i + 1}
            </Button>
          ))}
          <Button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="previous-btn-dataTable me-2"
          >
            Next
          </Button>
          <Button
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            className="previous-btn-dataTable me-2"
          >
            Last
          </Button>
        </div>
        <select
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
          className="ms-2 rounded border-0 px-2 py-1"
        >
          <option value={100}>100</option>
          <option value={200}>200</option>
          <option value={300}>300</option>
          <option value={500}>500</option>
        </select>
      </div>
    </>
  );
};

export default DataTable;
